var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3125 14.8572H1.6875C0.75375 14.8572 0 14.0915 0 13.1429V2.85717C0 1.9086 0.75375 1.14288 1.6875 1.14288H16.3125C17.2463 1.14288 18 1.9086 18 2.85717V13.1429C18 14.0915 17.2463 14.8572 16.3125 14.8572ZM1.6875 2.28574C1.3725 2.28574 1.125 2.53717 1.125 2.85717V13.1429C1.125 13.4629 1.3725 13.7143 1.6875 13.7143H16.3125C16.6275 13.7143 16.875 13.4629 16.875 13.1429V2.85717C16.875 2.53717 16.6275 2.28574 16.3125 2.28574H1.6875Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99985 10.24C8.21235 10.24 7.49235 9.92 6.95235 9.33715L1.0461 2.96C0.832353 2.73143 0.843603 2.36572 1.0686 2.14858C1.2936 1.93143 1.6536 1.94286 1.86735 2.17143L7.7736 8.54858C8.41485 9.24572 9.58485 9.24572 10.2261 8.54858L16.1324 2.18286C16.3461 1.95429 16.7061 1.94286 16.9311 2.16C17.1561 2.37715 17.1674 2.74286 16.9536 2.97143L11.0474 9.34858C10.5074 9.93143 9.78735 10.2514 8.99985 10.2514V10.24Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d94f14cc42a218858cc56c70dbeee203.svg";
export { ForwardRef as ReactComponent };